import PropTypes from 'prop-types'
import messages from '../../messages'
import { SelectionModal } from '../SelectionModal/SelectionModal'

export const CaptionsModal = ({
  subtitles,
  activeSubtitles,
  onSubtitlesChosen,
  onRequestClose,
  rightOffset = 0,
  dropUp,
}) => (
  <SelectionModal
    dropUp={dropUp}
    options={subtitles.map(({ languageName }) => ({ label: languageName }))}
    activeIndex={subtitles.findIndex(({ language }) => language === activeSubtitles)}
    onOptionIndexChosen={(index) => onSubtitlesChosen(subtitles[index]?.language)}
    onRequestClose={onRequestClose}
    rightOffset={rightOffset}
    defaultOptionMsg={messages.captionsOff}
  />
)

CaptionsModal.propTypes = {
  /** List of caption options */
  subtitles: PropTypes.array.isRequired,
  /** The language code of the active subtitles if any */
  activeSubtitles: PropTypes.string,
  /** Function to update active subtitles track */
  onSubtitlesChosen: PropTypes.func.isRequired,
  /** When present the controls menu is closed automatically after making a selection */
  onRequestClose: PropTypes.func,
  /** Additional right offset to the modal position */
  rightOffset: PropTypes.number,
  /** Open the modal above the CC button rather than below it */
  dropUp: PropTypes.bool,
}
